import React from "react";

const brands = [
  "D2C brands",
  "Agencies",
  "Regional startups",
  "Creator collectives",
  "Growth teams",
];

const TrustedBy = () => {
  return (
    <section className="px-4 pb-8">
      <div className="max-w-6xl mx-auto elevated-card rounded-[1.75rem] px-6 py-8 text-center">
        <h2 className="text-sm font-semibold uppercase tracking-[0.25em] text-slate-500 mb-5">
          Designed for trusted collaboration
        </h2>
        <div className="flex flex-wrap justify-center items-center gap-3">
          {brands.map((brand) => (
            <span
              key={brand}
              className="rounded-full border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-medium text-slate-700 shadow-sm"
            >
              {brand}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
